<main class="public-page">
  <menu-portale></menu-portale>

  <section-title title="Vantaggi"></section-title>

  <section class="portale-section portale-section--tint">
    <div class="feature-layout">
      <img class="feature-layout__image" src="./assets/portal/images/3_app/hero_1.png" alt="Applicazione Salute con te" />
      <div class="feature-layout__copy">
        <div class="feature-layout__item">
          <h3>Eviti code in studio</h3>
          <p>
            Potrai evitare di andare in studio a ritirare ricette, portare esiti, effettuare richieste evitando anche
            costi di parcheggio, benzina, etc.
          </p>
        </div>

        <div class="feature-layout__item">
          <h3>Saprai quando la tua ricetta è pronta</h3>
          <p>
            L'App installata sul tuo smartphone, con una semplice notifica, ti avvisa che il promemoria
            è pronto per essere stampato sulla stampante di casa.
          </p>
        </div>

        <div class="feature-layout__item">
          <h3>La tua cartella clinica sempre disponibile</h3>
          <p>
            Anche quando sei in vacanza o in trasferta lavorativa. Oppure quando il tuo medico curante non
            è disponibile.
          </p>
        </div>
      </div>
    </div>
  </section>


  <section class="portale-section portale-section--muted">
    <div class="feature-layout feature-layout--reverse">
      <div class="feature-layout__copy">
        <div class="feature-layout__item">
          <h3>Memorizzazione dei tuoi referti</h3>
          <p>
            Radiografie e referti storici da condividere o meno con il tuo medico.
          </p>
        </div>

        <div class="feature-layout__item">
          <h3>Monitoraggio più efficiente della TAO</h3>
          <p>
            I pazienti in TAO hanno la possibilità di visualizzare in qualsiasi momento la dose posologica del Coumadin
          </p>
        </div>

        <div class="feature-layout__item">
          <h3>Aiuto alla burocrazia</h3>
          <p>
            Possibilità di avere in qualsiasi momento accesso ai tuoi certificati di malattia INPS con il relativo
            numero di protocollo e tutte le fatture inviate al MEF per il 730 precompilato al ministero per la
            dichiarazione dei redditi.
          </p>
        </div>
      </div>
      <img class="feature-layout__image" src="./assets/portal/images/3_app/hero_2.jpg" alt="Consultazione dei dati sanitari" />
    </div>
  </section>

  <app-scarica-app-section></app-scarica-app-section>

  <app-portale-layout-footer></app-portale-layout-footer>
</main>
